module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAQCAMAAABA3o1rAAAAAXNSR0IB2cksfwAAADxQTFRFAAAAADZTADVTADVUADVUADVUADRUADhYADVUADBQADZUADRUADVVADZUADVUADVUADVTADVTADVUADVVW1UNrQAAABR0Uk5TAFCfv8//TyDvEIB/MOCg8N+QwNAspxuvAAAAhklEQVR4nH1PURaDIAwr2FBw4py7/11FxisojvylSdOUqMLYiQGerKMHiPVQeBvu+tzI2fK6yIHRgZuQxfd6Cll0X/VoRExUR7jnxzwJ6uDST0NNeVcHc/6vFiiRUmuckxX/DVgTfVfanYC/MGy/khvaneZCcjgR1+r40I4hdvqODUxjHTgApGAIjyCM69UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--dashboard.png
// module id = 927
// module chunks = 0